/** Desk SQLite career store, registered by the Tauri shell. Tests pass their own API. */

export type CareerDbMode = "unmigrated" | "sqlite" | "read_only" | "legacy";

export type CareerDbStatus = {
  mode: CareerDbMode;
  message: string;
  switched: boolean;
};

export type CareerDbFile = {
  name: string;
  text: string;
};

export type CareerDbApi = {
  status(): Promise<CareerDbStatus>;
  migrate(files: CareerDbFile[]): Promise<CareerDbStatus>;
  load(name: string): Promise<string | null>;
  save(name: string, json: string): Promise<void>;
};

let registered: CareerDbApi | null = null;
let notice: string | null = null;
const listeners = new Set<(message: string | null) => void>();

export function registerCareerDbApi(api: CareerDbApi | null): void {
  registered = api;
}

export function careerDbApi(): CareerDbApi | null {
  return registered;
}

export function careerStorageNotice(): string | null {
  return notice;
}

export function setCareerStorageNotice(message: string | null): void {
  const next = message && message.trim() ? message : null;
  if (next === notice) return;
  notice = next;
  for (const listener of listeners) listener(notice);
}

export function subscribeCareerStorageNotice(listener: (message: string | null) => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
